import { type RefObject, useEffect } from 'react';

let currentElementWithFocus;

export default function useSetDialogFocusEffect(ref: RefObject<HTMLElement>, shouldFocus: boolean) {
    useEffect(() => {
        let frameId: number;

        if (shouldFocus && ref?.current) {
            if (!currentElementWithFocus || currentElementWithFocus !== document.activeElement) {
                // Saves last focused element
                currentElementWithFocus = document.activeElement;
            }

            frameId = requestAnimationFrame(() => {
                // set focus in quickView
                ref.current?.focus();
            });
        }

        return () => {
            cancelAnimationFrame(frameId);
            if (currentElementWithFocus) {
                // set focus back on the previous element before the quickView opened
                (currentElementWithFocus as HTMLElement).focus();
                currentElementWithFocus = undefined;
            }
        };
    }, [shouldFocus, ref]);
}

// Can be used in Callback Ref
export function setDialogFocus(node, shouldFocus) {
    if (shouldFocus && node) {
        if (!currentElementWithFocus || currentElementWithFocus !== document.activeElement) {
            // Saves last focused element
            currentElementWithFocus = document.activeElement;
        }

        // set focus in quickView
        (node as HTMLElement).focus();

        return;
    }

    if (!node && currentElementWithFocus) {
        (currentElementWithFocus as HTMLElement).focus();
        currentElementWithFocus = undefined;
    }
}
